{
  "version": 1,
  "asset_id": "ae6b9dd1-74c6-4454-8325-2cb6aebbc36a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ae6b9dd1-74c6-4454-8325-2cb6aebbc36a/hiatal-intro-fundus-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ae6b9dd1-74c6-4454-8325-2cb6aebbc36a/hiatal-intro-fundus-es-480.webp",
  "original_filename": "hiatal-intro-fundus-es-480.webp",
  "size": 22060,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:38Z"
}
